const envFlag = process.env.VUE_APP_ENV

export default {
  env: envFlag,
  IS_DEV: envFlag === 'development'
}
